module.exports = __webpack_public_path__ + "static/eventx-banner-5958c5db4e9da40cc53f0bbf5fe1863b.mp4";